import * as React from 'react';
import Alert from 'antd/lib/alert';
import { Link } from 'react-router-dom';
import { createStepRunTabRoute, ReleaseStepTabType } from '@/helpers/routeHelpers';
import { BlockingChecklistItem } from '@/types/stepRunStatus';

interface BlockingChecklistItemsAlertProps {
    orgId: string;
    appId: string;
    version: string;
    items: BlockingChecklistItem[];
}

const BlockingChecklistItemsAlert: React.FC<BlockingChecklistItemsAlertProps> = ({ orgId, appId, version, items }) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <Alert
            closable={false}
            showIcon
            message={
                <div>
                    <div>{`${items.length} blocking checklist item${items.length > 1 ? 's are' : ' is'} incomplete for this step:`}</div>
                    <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
                        {items.map((item) => (
                            <li key={item.id}>
                                <Link
                                    to={createStepRunTabRoute(
                                        orgId,
                                        appId,
                                        version,
                                        item.stepRunId,
                                        ReleaseStepTabType.Checklist,
                                    )}
                                >
                                    {item.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            }
            type="warning"
        />
    );
};

export default BlockingChecklistItemsAlert;
